import IndiCov from './assets/projectsData/indicov.md';
import designandcode from './assets/projectsData/designandcode.md';
import Instagram from './assets/projectsData/instagram.md';
import peaceouthacks from './assets/projectsData/peaceouthacks.md';
import roomie from './assets/projectsData/roomie.md';
import attendancesystem from './assets/projectsData/attendance management system.md';
import ontrack from './assets/projectsData/ontrack.md';
import girlscriptgoa from './assets/projectsData/girlscriptgoa.md';
import hackingheist from './assets/projectsData/hackingheist.md';

const projects = [
  {
    id: 1,
    title: "IndiCov - A platform for all your covid needs.",
    description:
      "IndiCov is a platform that works towards helping patients during this pandemic by informing and constantly updating them of the covid stats and available resources. People can visit this site and check in the status of the resource availability according to the states or district wise.",
    shortDescription: "IndiCov is a platform that provides all the covid-19 related statistics for India and availability of the resources like beds, oxygen, medicines, etc in each state.",
    roles:
      "UI/UX Designer and Front-end Development.",
    technology: "ReactJS, Material UI, Figma.",
    clients: "Major League Hacking - Hackathon Project",
    tag: "Website & Design",
    image: "/assets/projects/indicov/indicov-banner.webp",
    content: IndiCov,
    projectLink: "https://indicov.vercel.app/",
    sourceCode: "https://github.com/DevrajDC/indicov",
    embedLinks: [
      "https://www.youtube.com/embed/9gCHokiOt2I",
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FwxNkpPOwHoKv7wdIHJBxD6%2FIndiCov---MLH-Hackathon%3Fnode-id%3D0%253A1",
    ],
  },
  {
    id: 2,
    title: "Instagram Redesign",
    description:
      "Instagram is a mobile, desktop, and Internet-based photo-sharing application and service that allows users to share pictures and videos either publicly or privately. In this project i have redesigned the entire Instagram mobile application and added features that i feel will improve the UX of the app.",
    shortDescription: "Instagram is a mobile, desktop, and Internet-based photo-sharing application and service that allows users to share pictures and videos either publicly or privately.",
    roles:
      "UI/UX & 3D Interaction Design, Front-end & Back-end Development, CMS.",
    technology: "Figma",
    clients: "Imagine Works Company",
    content: Instagram,
    tag: "App Design",
    image:
      "/assets/projects/instagram-redesign/instagram-redesign-banner.webp",
    descriptionImages: [
      "",
    ],
    projectLink: "",
    sourceCode: "",
    embedLinks: [
      
    ],
  },
  {
    id: 3,
    title: "Design and Code Community",
    description:
      "I founded Design & Code which is a global community with a mission to connect designers and developers to create a happy community eager to learn, innovate and grow together. We welcome all designers and developers: beginners, intermediates, and experts willing to learn together. ",
    shortDescription: "Design & Code is a global community with a mission to connect designers and developers to create a happy community eager to learn, innovate and grow together.",
    roles:
      "UI/UX & 3D Interaction Design, Front-end & Back-end Development, CMS.",
    technology: "ReactJS, Material UI, Figma.",
    clients: "Community Project",
    tag: "Website & Design",
    image:
      "/assets/projects/designandcode/designandcode-banner.webp",
    descriptionImages: [
      
    ],
    content: designandcode,
    projectLink: "https://designandcode.us",
    sourceCode: "https://github.com/Design-and-Code/Design-and-Code",
    embedLinks: [
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FvsUeSBdRVQCsCjnvuApQ0c%2FDevraj%252FDesign-%2526-Code-Community%3Fnode-id%3D570%253A571",
    ],
  },
  {
    id: 4,
    title: "Peace in Space",
    description:
      "We all experience stress in our day-to-day lives. This inspired us to create a platform where we could get refreshed, motivated, relaxed by listening to music and other activities as per our mood without filling any type of forms.",
    shortDescription: "A platform where we could get refreshed, motivated, relaxed by listening to music and other activities as per our mood without filling any type of forms.",
    roles:
      "UI/UX & Interaction Design and Front-end Development",
    technology: "HTML, CSS, JavaScript, Face API, Deep Learning, Figma",
    clients: "Major League Hacking - Hackathon Project",
    content: peaceouthacks,
    tag: "Website & Design",
    image:
      "/assets/projects/peaceinspace/peaceinspace-banner.webp",
    descriptionImages: [
      
    ],
    projectLink: "https://peace-in-space.vercel.app/",
    sourceCode: "https://github.com/Hackystellar/mlh-peaceout-hacks",
    embedLinks: [
      "https://www.youtube.com/embed/pbBaPebVaDA",
    ],
  },
  {
    id: 5,
    title: "Roomie",
    description:
      "An app that makes it safe to find the ideal roommate in a new city. It helps in finding the ideal roommate in the city as well as the one who is looking for the apartment.",
    shortDescription: "An app that makes it safe to find the ideal roommate in a new city. It helps in finding the ideal roommate in the city as well as the one who is looking for the apartment.",
    roles:
      "UI/UX & Interaction Design, Prototyping.",
    technology: "Figma Design",
    clients: "Imagine Works Company",
    content: roomie,
    tag: "App Design",
    image:
      "/assets/projects/roomie/roomie-banner.webp",
    descriptionImages: [
      
    ],
    projectLink: "",
    sourceCode: "",
    embedLinks: [
      
    ],
  },
  {
    id: 6,
    title: "Ontrack",
    description:
      "An app that helps you to find the best suitable notes, course materials and job/internship opportunities. Join with us to learn the best and contribute your notes to help your friends and juniors study better.",
    shortDescription: "Discover Engineering study material and Developmental courses. Uncover Job and internship opportunities to kick start with your career.",
    roles:
      "UI/UX Designer and Front-end Development.",
    technology: "ReactJS, Material UI, Figma Design",
    clients: "Personal Project",
    content: ontrack,
    tag: "Website & Design",
    image:
      "/assets/projects/ontrack/ontrack-banner.webp",
    descriptionImages: [
      
    ],
    projectLink: "https://ontrackweb.netlify.app/",
    sourceCode: "https://github.com/DevrajDC/ontrack",
    embedLinks: [
      
    ],
  },
  {
    id: 7,
    title: "GirlScript Goa",
    description:
      "GirlScript is a tech community for learning technical skills and getting opportunities around the globe. GirlScript is open for all organisation and supports beginners in technology and programming.",
    shortDescription: "GirlScript is a tech community for learning technical skills and getting opportunities around the globe.",
    roles:
      "UI/UX Designer and Front-end Development.",
    technology: "HTML, CSS, JavaScript, PHP, Laravel, Figma Design",
    clients: "GirlScript Foundation",
    content: girlscriptgoa,
    tag: "Website & Design",
    image:
      "/assets/projects/girlscriptgoa/girlscriptgoa-banner.webp",
    descriptionImages: [
      
    ],
    projectLink: "",
    sourceCode: "",
    embedLinks: [
      
    ],
  },
  {
    id: 8,
    title: "Hacking Heist",
    description:
      "Hacking Heist is a highly anticipated international hackathon organized by many famous student communities all over the world uniting together to produce a memorable event for talented students who possess the skills of different domains.",
    shortDescription: "Hacking Heist is an international hackathon organized by student communities uniting together to produce a memorable event for talented students who possess the skills of different domains.",
    roles:
      "UI/UX Designer and Front-end Development.",
    technology: "HTML, CSS, JavaScript,Figma Design",
    clients: "Hacking Heist",
    content: hackingheist,
    tag: "Website & Design",
    image:
      "/assets/projects/hackingheist/hackingheist-banner.webp",
    descriptionImages: [
      
    ],
    projectLink: "https://hackingheist.tech/",
    sourceCode: "",
    embedLinks: [
      
    ],
  },
  {
    id: 9,
    title: "Attendance Management System",
    description:
      "An attendance management system (dashboard) that shows every class’s schedule and activities for the day in the calendar, has a sub component that keeps track of all the events (activities and reminders) and also let you add new events for the desired time and place. Has a week view as well as a month view so that users can view the calendar by their preference.",
    shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    roles:
      "UI/UX & Interaction Design, Prototyping.",
    technology: "Figma Design",
    clients: "Edvora Company",
    content: attendancesystem,
    tag: "Web design",
    image:
      "/assets/projects/attendancemanager/attendancemanager-banner.webp",
    descriptionImages: [
      
    ],
    projectLink: "",
    sourceCode: "",
    embedLinks: [
      
    ],
  },
];

export default projects;